<div class="asset-metadata-container h-full">
  <div class="details px-4">
    <div class="detail-header" *ngIf="assetInfo">
      <ng-template ngFor let-assetObj [ngForOf]="assetInfoObject.formFields">
        <header class="general-info-details-header py-4" *ngIf="assetObj.fieldType === FieldType.Label">
          <h4 class="general-info-details-label text-xl !font-bold">{{ assetObj.fieldLabel }}</h4>
        </header>
        <div class="general-info-details-entry inline-block pb-2" [ngClass]="assetObj.widthClass" *ngIf="assetObj.fieldType === FieldType.Space"></div>
        <ng-template [ngIf]="assetInfo.customFields && assetInfo.customFields[assetInfoObject.stepperGroupName]">
          <div
            *ngIf="assetObj.fieldType !== FieldType.Label && assetObj.fieldType !== FieldType.FormArray && assetObj.fieldType !== FieldType.Space"
            class="general-info-details-entry inline-block text-base pb-2"
            [ngClass]="assetObj.widthClass"
          >
            <div class="general-info-details-entry pb-3 w-full flex">
              <div class="general-info-details-entry flex flex-row content-start w-full pr-6">
                <h4 class="general-info-details-label flex flex-row !font-bold w-1/2 pr-2 text-base align-top line-clamp-2">
                  {{ assetObj.fieldLabel }}
                </h4>
                <div
                  class="general-info-details-value w-1/2 text-base align-top line-clamp-2"
                  [matTooltip]="
                    assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName] && assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName].length > 30
                      ? assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName || ''].toString()
                      : null
                  "
                  *ngIf="assetObj.fieldType === FieldType.Text"
                >
                  {{
                    assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName]
                      ? assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName || ''].toString()
                      : '-'
                  }}
                </div>
                <div class="general-info-details-value w-1/2 text-base align-top line-clamp-2" *ngIf="assetObj.fieldType === FieldType.Date">
                  {{
                    assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName]
                      ? (assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName || ''].toString() | spDateFormat: { isSafe: true, plainDate: true })
                      : '-'
                  }}
                </div>
                <div class="general-info-details-value w-1/2 text-base align-top line-clamp-2" *ngIf="assetObj.fieldType === FieldType.Dropdown">
                  {{
                    assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName]
                      ? (assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName] | optionsLabel: assetObj.options)
                      : '-'
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="general-info-details-value inline-block text-base" *ngIf="assetObj.fieldType === FieldType.FormArray" [ngClass]="assetObj.widthClass">
            <ng-template ngFor let-fieldData [ngForOf]="assetInfo.customFields[assetInfoObject.stepperGroupName][assetObj.formFieldName]">
              <div class="general-info-details-entry pb-3 w-full flex">
                <ng-template ngFor let-formArrayFields [ngForOf]="assetObj.formFieldGroup">
                  <div class="general-info-details-entry flex flex-row content-start w-1/2 pr-6">
                    <h4 class="general-info-details-label content-start w-1/2 pr-2 !font-bold text-base align-top line-clamp-2">
                      {{ formArrayFields.fieldLabel }}
                    </h4>
                    <div
                      class="general-info-details-value content-start w-1/2 text-base align-top line-clamp-2"
                      [matTooltip]="fieldData[formArrayFields.formFieldName] && fieldData[formArrayFields.formFieldName].length > 30 ? fieldData[formArrayFields.formFieldName] : null"
                      *ngIf="formArrayFields.fieldType === FieldType.Text"
                    >
                      {{ fieldData[formArrayFields.formFieldName] ? fieldData[formArrayFields.formFieldName] : '-' }}
                    </div>
                    <div class="general-info-details-value content-start w-1/2 text-base align-top line-clamp-2" *ngIf="formArrayFields.fieldType === FieldType.Date">
                      {{ fieldData[formArrayFields.formFieldName] ? (fieldData[formArrayFields.formFieldName] | spDateFormat: { isSafe: true, plainDate: true }) : '-' }}
                    </div>
                  </div>
                </ng-template>
              </div>
            </ng-template>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>
